import PropTypes from 'prop-types';

import BaseUnitMessage from '../BaseUnitMessage/BaseUnitMessage';
import {
    getIconProps
} from '../../../helpers/helpers';
import {emitUrgencyUnitMessageEvent} from '../../../helpers/edap';

export default class UnitMessageComponent extends BaseUnitMessage {
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        unitMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string
                }),
            }),
            PropTypes.shape({
                iconTextV2: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string
                }),
            }),
            PropTypes.shape({
                iconText: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string
                }),
            })
        ]),
        /** If true, changes small greyscale icon to its color variant */
        color: PropTypes.bool,
        /** Set to true in order to hide the component from screen readers */
        ariaHidden: PropTypes.bool
    };

    componentDidMount() {
        const {messageValueType} = BaseUnitMessage.getUnitMessageContent(this.props.unitMessage);
        if (messageValueType) {
            emitUrgencyUnitMessageEvent(this.context, messageValueType);
        }
    }

    // eslint-disable-next-line complexity
    render() {
        const {className, size, unitMessage, color, ariaHidden} = this.props;
        const {icon, message} = BaseUnitMessage.getUnitMessageContent(unitMessage);
        if (!message) {
            return null;
        }

        const {style, src} = getIconProps(icon, size, color);

        return this.generateComponent({
            className,
            style,
            src,
            icon,
            message,
            size,
            ariaHidden
        });
    }
}
